export default {
    name: "adivare-flash-bag",
    props: ['scope'],
    computed: {
        flashes: function () {
            let flashes = this.$store.state.flashes;
            if (flashes === undefined || false === Array.isArray(flashes)) {
                return undefined;
            }
            return flashes.filter(x => x.scope === this.scope);
        },
        show: function () {
            return (undefined !== this.flashes && true === Array.isArray(this.flashes) && this.flashes.length > 0);
        }
    }
}